<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :refresh-table="getData"
      :bodyFilter="true"
      :customTopActions="true"
      item-key="id"
      table-height="70vh"
    >     
    <template v-slot:top>
      <TableTopNns
          :loading="loading"
          @addItem="addItem"
          @getData="getData"
        />
      </template>
      <template v-slot:body-prepend>
        <TablefilterNns :search.sync="search" :options.sync="options" v-on:getDataParent="getData" />
      </template>
      <template v-slot:action="{ item }">
        <td class="d-block d-sm-table-cell d-print-table-cell">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
          </td>
      </template>
      </TableView>

    <nns-management
      :dialogNNS="dialog"
      :editedItem="editedItem"
      :editedIndex="editedIndex"
      v-on:closeCancelParent="close"
    />
  </v-card>
</template>

<script>

import nnsManagementMixin from '../../components/nns-management/nnsManagementMixin';
import { TablefilterNns, TableTopNns } from '../../components/nns-management/components';

export default {
  mixins: [nnsManagementMixin],
  components: {
    nnsManagement: () => import('../../components/form/NnsManagement.vue'),
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    TablefilterNns,
    TableTopNns,
  },
};
</script>